<template>
    <div id="ClazzSection">
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection"
                  @keyup.enter.native="doSearch()">
                <FormItem prop="keyword">
                    <Input type="text" v-model="searchForm.keyword" placeholder="名称"></Input>
                </FormItem>
                <Form-item prop="zone_id" label="校区" :label-width="60">
                    <Select v-model="searchForm.zone_id" filterable style="width: 250px" >
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem>
                    <Button type="primary" @click="doSearch" size="small">搜索</Button>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="add" size="small">新增</Button>
                </FormItem>
            </Form>
            <Table :columns="columns" :data="data" :loading="dataLoading"></Table>
            <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total
                  @on-change="changePage" :page-size="20"></Page>
        </card>
        <clazz-form ref="ClazzForm" v-on:success="onSuccess"></clazz-form>
        <Modal v-model="finishModal" width="360">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>确认进行结班操作？</span>
            </p>
            <div style="text-align:center">
                <p>将删除本班所有未上课程（此操作不可恢复）？</p>
                <p>是否确认操作?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="finish">确认结班</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
  import ClazzForm from './form.vue';

  export default {
    name: 'clazz_index',
    data() {
      return {
        choosed:null,
        finishModal:false,
        searchForm: {
          keyword: ''
        },
        columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '校区',
            key: 'zone_name'
          },
          {
            title: '课程',
            key: 'course_name'
          },
          {
            title: '学生数',
            key: 'student_count'
          },
          {
            title: '上课时间',
            width:320,
            render: (h, params) => {
              let self = this;
              let contentArray = [];
              if (params.row.dateList && params.row.dateList.length > 0){
                params.row.dateList.forEach(ele => {
                  contentArray.push(h('div', {}, "["+ele.teacherName + "] " + ele.begin_date + ' 到 ' + ele.end_date + " 剩余"+ele.num+"次课"));
                  ele.timeList.forEach((item, idx) => {
                    contentArray.push(h('div', {}, self.$xmutils.parseWeekDay(item.weekday) + item.start + ' - ' + item.end));
                  });
                });
              }

              return h('div', contentArray);
            }
          },
          {
            title: '状态',
            key: 'state',
            render: (h, params) => {
              if (params.row.state == 1){
                return h('Tag',
                  {
                    props: {
                      color: 'primary'
                    },
                  },'正常');
              }else if (params.row.state == 2){
                return h('Tag',
                  {
                    props: {
                      color: 'error'
                    },
                  },'下架');
              }else if (params.row.state == 3){
                return h('Tag',
                  {
                    props: {
                      color: 'success'
                    },
                  },'已结班');
              }

            }
          },
          {
            title: '操作',
            width: 250,
            render: (h, params) => {
              let self = this;

              let opArray = [];

              opArray.push(h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'clazz_detail',
                      query: {
                        id: params.row.id,
                      }
                    })
                  }
                }
              }, '详情'));

              if (params.row.state != 3){
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.ClazzForm.showWin(params.row.id);
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let self = this;
                      self.choosed = params.row.id;
                      self.finishModal = true;
                    }
                  }
                }, '结班'));
              }

              if (params.row.account != 'admin') {
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      self.$Modal.confirm({
                        title: '提示',
                        content: '是否确定删除？',
                        onOk: () => {
                          self.$api.clazz.remove({id: params.row.id}).then(resp => {
                            if (resp.state == 'ok') {
                              self.$Message.info('删除成功');
                              self.getList();
                            } else {
                              this.saving = false;
                              self.$Message.error(resp.msg);
                            }
                          });
                        },
                        onCancel: () => {

                        }
                      });
                    }
                  }
                }, '删除'));
              }

              return h('div', opArray);

            }
          }
        ],
        data: [],
        dataLoading: false,
        ruleInline: {},
        totalPage: 0,
        pageTotalNum: 0,
        pageCurrent: 1
      }
    },
    computed: {
      showPager: function () {
        return this.totalPage > 1
      },
      zoneList() {
        return this.$store.state.app.zoneList
      },
    },
    methods: {
      finish(){
        let self = this;
        self.$api.clazz.finish({id: self.choosed}).then(resp => {
          if (resp.state == 'ok') {
            self.$Message.info('结班成功');
            self.getList();
            self.finishModal = false;
          } else {
            this.saving = false;
            self.$Message.error(resp.msg);
          }
        });
      },
      getList() {
        this.dataLoading = true;
        let param = {
          pageNumber: this.pageCurrent,
          pageSize: 20,
          keyword : this.searchForm.keyword,
          zone_id: this.searchForm.zone_id
        }
        this.$api.clazz.getList(param).then(resp => {
          this.data = resp.data.list;
          this.pageTotalNum = resp.data.totalRow;
          this.totalPage = resp.data.totalPage;
          this.pageCurrent = resp.data.pageNumber;
          this.dataLoading = false;
        });
      },
      add() {
        this.$refs.ClazzForm.showWin();
      },
      changePage(page) {
        this.pageCurrent = page;
        this.getList();
      },
      doSearch() {
        this.pageCurrent = 1;
        this.getList();
      },
      onSuccess() {
        this.pageCurrent = 1;
        this.getList();
      }
    },
    mounted: function () {
      this.getList();
    },
    components: {
      ClazzForm
    }
  }
</script>
